<template>
	<v-card class="w-100 elevation-1 rounded-1 steps-card">
		<v-row>
			<v-col cols="12" sm="12" md="6" lg="5" class="pa-0 flex-center">
				<v-list class="py-3 w-100">
					<v-list-item
						v-for="(step, index) in steps"
						:key="index"
						@click="setActiveStep(index)"
						:color="index === activeStep ? 'primary' : ''"
						class="py-5 px-md-15 px-10 w-100"
						:class="index === activeStep ? 'active-step' : ''"
						style="cursor: pointer">
						<div class="d-flex align-center justify-start" style="overflow: visible">
							<div class="icon-wrap pa-4 rounded-1 mr-7" style="background-color: #0e081820">
								<v-icon :color="index === activeStep ? '#0e0818' : '#0e081850'">{{ step.icon }}</v-icon>
							</div>

							<div class="w-100">
								<div class="w-100 d-flex align-center justify-space-between">
									<h3
										class="text-left font-weight-regular"
										:class="index === activeStep ? '' : 'text-disabled w-100'">
										{{ step.title }}
									</h3>
									<v-icon v-if="index !== activeStep" class="ml-2" color="#0e081860">
										mdi-chevron-down
									</v-icon>
								</div>

								<p
									class="text-left font-weight-light w-100 text-medium-emphasis"
									v-if="index === activeStep">
									{{ step.description }}
								</p>
							</div>
						</div>
					</v-list-item>
				</v-list>
			</v-col>

			<!-- Right Column: Image of the active step -->
			<v-col
				cols="12"
				sm="12"
				md="6"
				lg="7"
				class="flex-center py-12 px-md-15 px-10 active-step position-relative">
				<img
					v-if="currentStepImage && currentStepImage !== 'grid.png'"
					:src="`../../assets/${currentStepImage}`"
					alt="Step Image"
					style="max-height: 338px; width: 100%; object-fit: contain" />

				<img
					v-else-if="currentStepImage && currentStepImage === 'grid.png'"
					:src="`../../assets/${currentStepImage}`"
					alt="Step Image"
					style="width: 105% !important; object-fit: contain; margin-right: -30%; margin-bottom: -20%" />
			</v-col>
		</v-row>
	</v-card>
</template>

<script setup>
	import { ref, computed } from "vue"

	const props = defineProps({
		steps: {
			type: Array,
			default: () => [
				{
					icon: "mdi-view-dashboard",
					title: "Workspace",
					description:
						"Your hub for everything—manage your plans, tools, documents, and conversations in one place. Invite partners as your workspace collaborators to build greatness together.",
					image: "workspace.png",
				},
				{
					icon: "mdi-tools",
					title: "AI Marketing Tools",
					description:
						"Access 80+ Creative Generators That Sell! Ads, emails, posts, product copy, all trained on your business context. No templates. Just smart results.",
					image: "grid.png",
				},
				{
					icon: "mdi-chat",
					title: "AI Business Consultant",
					description:
						"Chat with your personal AI Co-founder. It understands your goals, your audience, and your challenges—and gives tailored answers, instantly. Available 24/7.",
					image: "chat.png",
				},
				{
					icon: "mdi-brain",
					title: "Knowledge Base",
					description:
						"A custom knowledge base using your business plan and marketing strategy—so every answer is precise, personalized, and always on-point.",
					image: "knowledge.png",
				},
			],
		},
	})

	const activeStep = ref(0)

	function setActiveStep(index) {
		activeStep.value = index
	}

	const currentStepImage = computed(() => {
		return props.steps[activeStep.value]?.image ?? ""
	})
</script>

<style scoped lang="scss">
	.active-step {
		background-color: #958fc533;
	}

	.steps-card {
		transition: all 0.3s ease;

		* {
			transition: all 0.3s ease;
		}
	}
</style>
